/* ================================================================
   VC Rig Carousel — JS-driven horizontal marquee. Reads a manifest
   embedded as a <script type="application/json"> and builds the DOM.
   Only the back view is rendered per rig (no view rotation). The
   marquee translates the track continuously; hover does NOT pause.
   Expected manifest shape:
     { "rigs": [ { "id": "001", "theme": "…", "views": { "back": "...", "front": "...", "left": "...", "right": "..." } }, … ] }
   ================================================================ */
(function () {
  'use strict';

  var MARQUEE_PX_PER_SEC = 40;   // horizontal slide speed

  function init() {
    var carousel = document.querySelector('.vc-rig-carousel');
    if (!carousel) return;
    var manifestEl = carousel.querySelector('script[type="application/json"][data-rig-manifest]');
    if (!manifestEl) return;
    var track = carousel.querySelector('.vc-rig-track');
    if (!track) return;

    var manifest;
    try { manifest = JSON.parse(manifestEl.textContent || '{}'); }
    catch (e) { console.warn('[vc-rig-carousel] manifest parse failed', e); return; }
    var rigs = manifest.rigs || [];
    if (!rigs.length) { carousel.style.display = 'none'; return; }

    // Duplicate the list so translating the track -halfWidth loops seamlessly.
    var doubled = rigs.concat(rigs);

    var frag = document.createDocumentFragment();
    doubled.forEach(function (rig, i) {
      var card = document.createElement('div');
      card.className = 'vc-rig-card';
      card.setAttribute('data-rig-id', rig.id || String(i));

      var wrap = document.createElement('div');
      wrap.className = 'vc-rig-3d-wrap';

      var spinner = document.createElement('div');
      spinner.className = 'vc-rig-3d';

      // Single-view render — back only. No rotation between views.
      var src = rig.views && rig.views.back;
      if (src) {
        var img = document.createElement('img');
        img.className = 'view-back is-visible';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.src = src;
        spinner.appendChild(img);
      }
      wrap.appendChild(spinner);
      card.appendChild(wrap);

      frag.appendChild(card);
    });

    track.appendChild(frag);
    carousel.classList.remove('vc-rig-carousel--loading');

    // Marquee — translate track leftward; when it's moved one full list-width,
    // snap back to 0 (the doubled list makes this invisible). Runs forever,
    // no hover pause.
    var offset = 0;
    var halfWidth = 0;
    function measure() { halfWidth = track.scrollWidth / 2; }
    requestAnimationFrame(function () { requestAnimationFrame(measure); });
    window.addEventListener('resize', measure);

    var last = performance.now();
    function frame(t) {
      var dt = Math.min(100, t - last);
      last = t;
      if (halfWidth > 0) {
        offset -= (MARQUEE_PX_PER_SEC * dt) / 1000;
        if (-offset >= halfWidth) offset += halfWidth;
        track.style.transform = 'translate3d(' + offset.toFixed(2) + 'px, 0, 0)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
